module.exports = __webpack_public_path__ + "static/media/arrow.212d0cf5.svg";